import { EventTicketData } from '../../types';

export const shirtSizeOptions = ['SM', 'MD', 'LG', 'XL', '2XL', '3XL'];

export const mealTypeOptions = [
  {
    value: 'Standard Meal',
    description: '',
  },
  {
    value: 'Special Meal',
    description:
      'includes: vegetarian, vegan, gluten-free, and other common dietary accommodations',
  },
];

export const mealNote =
  'We will do our best to accommodate dietary preferences and restrictions; however, we cannot guarantee that all specific dietary needs will be met. If you have a severe allergy or restriction, we recommend planning accordingly.';

export const getSelectionStatus = (params: {
  ticket: EventTicketData | undefined;
  shirtSizes: { [key: number]: string };
  mealTypes: { [key: number]: string };
  ticketCount: string;
}) => {
  const { ticket, shirtSizes, mealTypes, ticketCount } = params;

  // The user has selected a ticket that includes shirts
  // This checks to see if they have selected a shirt size for each ticket
  const needsToSelectShirts: boolean = Boolean(
    ticket &&
      ticket.ReqShirtSize === 1 &&
      !(Object.values(shirtSizes).length === Number(ticketCount)),
  );

  // The user has selected a ticket that includes meals
  // This checks to see if they have selected a meal type for each ticket
  const needsToSelectMeals: boolean = Boolean(
    ticket &&
      ticket.ReqMealType === 1 &&
      !(Object.values(mealTypes).length === Number(ticketCount)),
  );

  return { needsToSelectShirts, needsToSelectMeals };
};
